import {useBoolean} from 'usehooks-ts'

import {Button} from '@sdox/ui'
import {useDocumentLazyQuery} from '@sdox/api'

import {getIcon, sizeMap, variantMap} from '../utils'
import {DocumentButtonDialog} from './DocumentButtonDialog'

import type {TrackingProps} from '@sdox/utils/dom'
import type {ButtonInterface_DocButtonType_Fragment} from '@sdox/api'

type DocumentButtonProps = ButtonInterface_DocButtonType_Fragment

export const DocumentButton = (props: DocumentButtonProps) => {
  const {size, variant, leadingIcon, trailingIcon, mboAttrs, label, docIdentifier} = props
  const {setTrue: openDialog, setFalse: closeDialog, value: isDialogOpen} = useBoolean()
  const [getDocument] = useDocumentLazyQuery({
    variables: {
      identifier: docIdentifier,
    },
    fetchPolicy: 'cache-first',
  })

  const loadData = async () => {
    await getDocument()
  }

  return (
    <>
      <Button
        onMouseEnter={loadData}
        size={sizeMap[size]}
        variant={variantMap[variant]}
        leading={getIcon(leadingIcon)}
        trailing={getIcon(trailingIcon)}
        onClick={openDialog}
        mboAttrs={mboAttrs as TrackingProps}
      >
        {label}
      </Button>
      <DocumentButtonDialog
        isOpen={isDialogOpen}
        onClose={closeDialog}
        identifier={docIdentifier}
      />
    </>
  )
}
